/**
 * Managed ResizeObserver instances — batch callbacks and disconnect on lifecycle events.
 */

const managedObservers = new Set();
let guardInstalled = false;

export function disconnectAllManagedResizeObservers() {
    managedObservers.forEach((observer) => {
        try {
            observer.disconnect();
        } catch {
            /* ignore */
        }
    });
    managedObservers.clear();
}

export function installResizeObserverGuard() {
    if (guardInstalled || typeof window === "undefined" || !window.ResizeObserver) return;
    guardInstalled = true;

    const NativeResizeObserver = window.ResizeObserver;

    window.ResizeObserver = class FairShareResizeObserver extends NativeResizeObserver {
        constructor(callback) {
            let rafId = null;
            const wrapped = (entries, observer) => {
                if (rafId != null) cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(() => {
                    rafId = null;
                    try {
                        callback(entries, observer);
                    } catch (err) {
                        console.warn("[FairShare] ResizeObserver callback error:", err);
                    }
                });
            };
            super(wrapped);
            managedObservers.add(this);
        }

        disconnect() {
            managedObservers.delete(this);
            super.disconnect();
        }
    };
}
